// generated from 181 samples

import { z } from "zod";
import { common } from "../common";

export const landingPageFormSubmittedTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::LandingPageFormSubmitted"),
  // null: 3 (1.66%)
  external_id: common.uuid.nullable(),
  name: z.string().nullable(),
});
